<div class="legal-links-wrapper links-wrapper">
    <eon-ui-link
        iconPosition="{{iconPosition}}"
        hideIcon="true"
        slot="links"
        size="small"
        text="{{'link.imprint' | translate}}"
    />
    <eon-ui-link
        iconPosition="{{iconPosition}}"
        slot="links"
        hideIcon="true"
        size="small"
        text="{{'link.data privacy' | translate}}"
    />
    <eon-ui-link
        iconPosition="{{iconPosition}}"
        slot="links"
        hideIcon="true"
        size="small"
        text="{{'link.used licenses' | translate}}"
    />
</div>
